/*
  I chose this file to be .jsx instead of .tsx because
  there are no type definitions for the react-jss library
*/

import React from 'react'

import JssProvider from 'react-jss/lib/JssProvider'
import { create } from 'jss'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true,
  productionPrefix: 'c'
})

const jss = create(jssPreset())

/*
  custom insertion point that JSS will look for when injecting the styles in the DOM
*/
jss.options.insertionPoint = document.getElementById('jss-insertion-point')

export default ({ children }) => (
  <JssProvider jss={jss} generateClassName={generateClassName}>
    {children}
  </JssProvider>
)



// WEBPACK FOOTER //
// ./src/contexts/JSSInsertionPointOverride.jsx